import { NAME } from "./constants";

export const SIGN_IN = NAME + "_SIGN_IN";
export const SIGN_OUT = NAME + "_SIGN_OUT";
